import { Component, OnInit } from '@angular/core';
import { IssuesService } from 'src/app/_services/issues.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-signed-off-issues-list',
  templateUrl: './signed-off-issues-list.component.html',
  styleUrls: ['./signed-off-issues-list.component.scss'],
})
export class SignedOffIssuesListComponent implements OnInit {
  loadingSignOff$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );

  signOffFilter: string = '';
  signOffSearch = '';

  signedOffData: any[] = [];
  totalSignedOffRecords = 0;

  signedOffColumns = [
    { field: 'vehicle_reference', header: 'Vehicle Reference' },
    { field: 'description', header: 'Description' },
    { field: 'fine_amount', header: 'Fine Amount' },
    { field: 'signoff_type', header: 'Signoff Type' },
    { field: 'date_signed_off', header: 'Date Signed Off' },
  ];

  constructor(private issuesService: IssuesService) {}

  ngOnInit(): void {
    this.loadSignedOffIssues({ first: 0, rows: 5 });
  }

  loadSignedOffIssues(event: any) {
    const page = Math.floor(event.first / event.rows) + 1;
    const rows = event.rows;

    this.issuesService
      .getSignedOffIssues(page, rows, this.signOffFilter)
      .subscribe((data: any) => {
        this.signedOffData = data.body.records;
        this.totalSignedOffRecords = data.body.total_records;
        this.loadingSignOff$.next(false);
      });
  }

  filterSignOffGlobal(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.signOffSearch = inputElement.value.trim();
    this.signOffFilter = this.signOffSearch;
    this.loadSignedOffIssues({ first: 0, rows: 5 });
  }

  clearSignOffSearch() {
    this.signOffSearch = '';
    this.signOffFilter = '';
    this.loadSignedOffIssues({ first: 0, rows: 5 });
  }
}
